module.exports = __webpack_public_path__ + "static/media/header.96ca7698.jp2";